import axios from "axios"

import { LocalStorageService } from "../api-service/LocalStorageService"
import { API_ACCESS_KEY, REACT_APP_WORKER_BASE_URL } from "./NewsletterOfferWorkerClient"

export const KnowledgeBaseWorkerClient = axios.create({
  baseURL: `${REACT_APP_WORKER_BASE_URL}/chat`,
  headers: {
    "Content-Type": "application/json",
    "X-Access-Key": API_ACCESS_KEY,
  },
})

KnowledgeBaseWorkerClient.interceptors.request.use(config => {
  const key = process.env.REACT_APP_CHAT_ADMIN_API_KEY
  config.headers!["X-Access-Key"] = API_ACCESS_KEY

  if (key && config.headers) {
    config.headers["X-Api-Key"] = key
  }
  if (config.url!.includes(":profileId")) {
    const profileId = LocalStorageService.getObject("profileId")
    if (profileId) {
      config.url = config.url!.replace(":profileId", profileId)
    }
  }
  return config
})

KnowledgeBaseWorkerClient.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error),
)
